import { CALL_API } from '../login/api.middleware';
import { AFFILIATE_SERVICE_URL } from '../constants/api';
import * as type from '../constants/ActionTypes';

export function fetchClients() {
  return {
    [CALL_API]: {
      endpoint: `${AFFILIATE_SERVICE_URL}/affiliates/clients`,
      types: [
        type.CLIENT_LIST_REQUEST,
        type.CLIENT_LIST_SUCCESS,
        type.CLIENT_LIST_FAILURE
      ],
      authenticated: true
    }
  };
}

